import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { ToastModule } from "primeng/toast";

@Component({
  selector: "db-toast",
  standalone: true,
  imports: [CommonModule, ToastModule],
  template: `<div class="db-toast">
    <p-toast
      [baseZIndex]="9999"
      position="top-center"
      [showTransitionOptions]="'300ms ease-out'"
      [hideTransitionOptions]="'250ms ease-in'"
    ></p-toast>
  </div>`,
  styleUrls: ["./toast.component.scss"],
})
export class ToastComponent {}
